<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddAnEvent"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form @submit.prevent="create">
          <div
            class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full h-full overflow-y-scroll my-5"
          >
            <transition name="fade">
              <div
                v-if="loading"
                class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
              >
                <loader class="center-h-v" />
              </div>
            </transition>

            <div class="flex justify-between items-center border-b-1.5 p-3">
              <p class="text-base">Add Event</p>
              <img
                v-if="!loading"
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
              />
            </div>
            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <transition name="fade">
              <div
                v-if="create_success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <div class="grid grid-cols-1 md:grid-cols-1 p-4 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Title</label>
                <input
                  v-model="info.Title"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Title"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Location</label>
                <input
                  v-model="info.Location"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Location"
                />
              </div>
              <div class="text-sm">
                <label class="block pb-1">Visibility</label>
                <select
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="info.Visibility"
                >
                  <option value="1">Public</option>
                  <option value="2">Department</option>
                </select>
              </div>
              <div class="text-sm" v-if="info.Visibility == 2">
                <label class="block pb-1">Department</label>

                <el-select
                  filterable
                  class="bg-gray-200 rounded-full w-full border-none"
                  v-model="info.DepartmentId"
                  placeholder="Select a type"
                >
                  <el-option
                    v-for="department in departments"
                    :key="department.DepartmentId"
                    :label="department.Name"
                    :value="department.DepartmentId"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="text-sm">
                <label class="block pb-1">StartDate</label>

                <el-date-picker
                  v-model="info.StartDateTime"
                  type="datetime"
                  class="w-full width"
                  placeholder=" Select date and time "
                >
                </el-date-picker>
              </div>
              <div class="text-sm">
                <label class="block pb-1">EndDate</label>
                <el-date-picker
                  v-model="info.EndDateTime"
                  type="datetime"
                  class="w-full form-control width"
                  placeholder=" Select date and time"
                >
                </el-date-picker>
              </div>
              <div class="text-sm">
                <label class="block pb-1">Event Type</label>
                <input
                  v-model="info.EventType"
                  type="text"
                  class="p-2 bg-gray-200 rounded-full w-full"
                  placeholder="Event Type"
                />
              </div>

              <div class="text-sm">
                <label class="block pb-1">Description</label>

                <textarea
                  v-model="info.Description"
                  class="p-2 bg-gray-200 rounded-xl w-full"
                  cols="5"
                  placeholder="Description"
                  :required="info.Emergency"
                ></textarea>
              </div>
              <div class="text-sm">
                <label class="block pb-1"></label>
              </div>
              <div class="flex justify-end px-5">
                <button
                  class="bg-primary rounded-full px-10 text-sm text-white py-2"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      >
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "AddAnEvent",
  props: ["showAddAnEvent", "reload"],
  components: { Loader },
  departments: [],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "Yesterday",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "A week ago",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      value3: "",

      info: {
        Title: "",
        Description: "",
        StartDateTime: "",
        EndDateTime: "",
        Location: "",
        EventType: "",
        Visibility: 0,
        DepartmentId: "",
      },
      create_error: null,
      create_success: null,

      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getDepartments();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.departments = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/type/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.info.Visibility = parseInt(this.info.Visibility);
      axios
        .post(
          `${this.getOrganization}/event/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.info = {
                Title: "",
                Description: "",
                StartDateTime: "",
                EndDateTime: "",
                Location: "",
                EventType: "",
                Visibility: 0,
                DepartmentId: "",
              };
              setTimeout(() => {
                this.create_success = null;
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.width {
  width: 100%;
}
</style>
